import React, {useContext, useState} from "react";
import {ModalContext, ModalDispatch} from "../context/ModalContext";
import WCLoginService from "../services/WCLoginService";
import {LoaderDispatch} from "../context/LoaderContext";
import {useLanguage} from "../context/LanguageContext";

const PasswordChangeForm = ({email}) => {
    const {t} = useLanguage();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const modal = useContext(ModalContext);
    const modalDispatch = useContext(ModalDispatch);
    const loaderDispatch = useContext(LoaderDispatch);
    const handleChangePassword = async (e) => {
        e.preventDefault();
        loaderDispatch({type: 'activate'});
        modalDispatch({type: 'clear'});

        if (password !== confirmPassword) {
            modalDispatch({
                type: 'setErrorMsg',
                payload: t('auth.passwordsMismatch')
            });
            return;
        }

        if(password.length < 8) {
            modalDispatch({
                type: 'setErrorMsg',
                payload: t('auth.passwordMinLength')
            });
            return;
        }

        const response = await WCLoginService.resetPassword(email, password);

        if(response.status === 'error') {
            modalDispatch({
                type: 'setErrorMsg',
                payload: response.message
            });
        } else {
            modalDispatch({
                type: 'setSuccessMsg',
                payload: response.message
            });
            modalDispatch({type: 'setModalContent', payload: {content: '' , title: t('auth.passwordReset')}});
        }
        loaderDispatch({type: 'deactivate'});
    }

    return (
        <form onSubmit={handleChangePassword} aria-label={t('auth.changePasswordFormLabel')}>
            <div className="mb-3">
                <label htmlFor="password" className="form-label">{t('auth.password')}</label>
                <input
                    type="password"
                    className="form-control"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    aria-required="true"
                    aria-label={t('auth.password')}
                    autoComplete="new-password"
                />
            </div>
            <div className="mb-3">
                <label htmlFor="confirmPassword" className="form-label">{t('auth.confirmPassword')}</label>
                <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    aria-required="true"
                    aria-label={t('auth.confirmPassword')}
                    autoComplete="new-password"
                />
            </div>
            <button type="submit" className="btn btn-primary" aria-label={t('auth.changePassword')}>{t('auth.changePassword')}</button>
        </form>
    )
}

export default PasswordChangeForm;
